import {Accordion} from "react-bootstrap";
import React from "react";
import Translate from "../Translate";

export default function NsAccordion({
                         titolo,
                         children,
                         label = '',
                         key = '0'
                     }) {

    return (
        <Accordion className={'mb-3'}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    {
                        label && label !== '' &&
                        <i className={label + ' ns-tree-row-icon pe-2'}/>
                    }
                    <Translate>{titolo}</Translate>
                </Accordion.Header>
                <Accordion.Body>
                    {
                        children
                    }
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}